var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoDummyLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2264_5968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8344 32.9861H2.16556C0.966767 32.9861 0 32.0193 0 30.8205V28.713C0 23.5698 3.40302 18.968 8.70091 16.6864C7.01873 14.8882 6.0713 12.4906 6.0713 9.93837C6.0713 4.46647 10.5184 0 16.0097 0C21.5009 0 25.948 4.46647 25.948 9.93837C25.948 12.4906 25.0006 14.8689 23.3184 16.6864C28.6163 18.968 32.0193 23.5505 32.0193 28.713V30.8205C32.0193 32.0193 31.0526 32.9861 29.8538 32.9861H29.8344ZM2.82296 30.1631H29.177V28.713C29.177 24.1692 25.4453 19.9928 20.1088 18.5619C19.5674 18.4073 19.1613 17.9625 19.084 17.4018C19.0066 16.8411 19.258 16.2804 19.7414 15.9903C21.8489 14.6949 23.1251 12.4326 23.1251 9.93837C23.1251 6.01329 19.9347 2.82296 16.0097 2.82296C12.0846 2.82296 8.89426 6.01329 8.89426 9.93837C8.89426 12.4326 10.1511 14.6949 12.2779 15.9903C12.7613 16.2804 13.0127 16.8411 12.9353 17.4018C12.858 17.9625 12.452 18.4266 11.9106 18.5619C6.57402 19.9928 2.8423 24.1692 2.8423 28.713V30.1631H2.82296Z",
    fill: "#A3ABB7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2264_5968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32.9861,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDummyLight);
export default __webpack_public_path__ + "static/media/ico-dummy-light.78b050cc210d9e68307752df24899253.svg";
export { ForwardRef as ReactComponent };